import { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import logo from "../assets/logos/Anathameenakshi_no_bg.png"

export const Navbar = ({ activeCompany }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setMobileMenuOpen(false);
  };

  return (
    <nav
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        isScrolled ? 'bg-obsidian/95 backdrop-blur-md border-b border-white/5' : 'bg-transparent'
      }`}
    >
      <div className="max-w-9xl mx-auto px-6 md:px-12">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <a href="/" className="flex items-center gap-2" data-testid="logo">
            <div className="pt-2 w-16 h-16 sm:w-20 sm:h-20 md:w-24 md:h-24 flex items-center justify-center ">
              <img
               src={logo}
               alt="AnanthaMeenakshi Architect's logo"
               className="h-full w-full object-cover"
             />
            </div>
            
            <div className="flex items-center flex  sm:flex-row items-start sm:items-center md:flex-wrap">
              <span className="font-heading text-lg sm:text-xl font-semibold text-gold ml-1">AnanthaMeenakshi  </span>
              <span className="font-heading text-lg sm:text-xl sm:font-semibold text-white ml-1"> Groups </span>
            </div>
          </a>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            <button
              onClick={() => scrollToSection('services')}
              className="text-sm font-medium text-gray-300 hover:text-gold transition-colors uppercase tracking-wider"
              data-testid="nav-services"
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('projects')}
              className="text-sm font-medium text-gray-300 hover:text-gold transition-colors uppercase tracking-wider"
              data-testid="nav-projects"
            >
              Projects
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="text-sm font-medium text-gray-300 hover:text-gold transition-colors uppercase tracking-wider"
              data-testid="nav-about"
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="btn-primary text-sm"
              data-testid="nav-contact"
            >
              Contact Us
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden p-2 text-white"
            data-testid="mobile-menu-toggle"
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-obsidian-paper border-t border-white/5" data-testid="mobile-menu">
          <div className="px-6 py-4 space-y-4">
            <button
              onClick={() => scrollToSection('services')}
              className="block w-full text-left text-gray-300 hover:text-gold py-2 uppercase tracking-wider text-sm"
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('projects')}
              className="block w-full text-left text-gray-300 hover:text-gold py-2 uppercase tracking-wider text-sm"
            >
              Projects
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="block w-full text-left text-gray-300 hover:text-gold py-2 uppercase tracking-wider text-sm"
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="btn-primary w-full text-sm mt-4"
            >
              Contact Us
            </button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;

